export default __webpack_public_path__ + "f60465c6bd1728386a3645ffc4bf7c60.svg";